import { Hero } from "@/components/home/Hero";
import { LatestDrop } from "@/components/home/LatestDrop";
import { EditorialSplit } from "@/components/home/EditorialSplit";
import { JesterTeaser } from "@/components/home/JesterTeaser";

export default function Home() {
  return (
    <>
      <Hero />
      <LatestDrop />
      <JesterTeaser />
      <EditorialSplit />
    </>
  );
}
